module.exports = __webpack_public_path__ + "5d2774b5d03970843fbb17ae039a8475.jpg";